require('../../modules/core.regexp.escape');
module.exports = require('../../modules/_core').RegExp.escape;



//////////////////
// WEBPACK FOOTER
// ./apps/guias/~/core-js/fn/regexp/escape.js
// module id = 130
// module chunks = 0